import React from "react"
import "./styles.scss"

export const ProgressBar = ({className, currentValue = 0, maxValue = 100}) => {
  return (
    <progress className={`custom-progress-bar ${className ? `${className}` : ""}`} value={currentValue} max={maxValue}>
      {currentValue}%
    </progress>
  )
}
